import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69bfd8007d947e00143a28d7_1780836840667_06493200/compatibirth/src/app/compatibility-reader/components/CompatibilityReaderClient.tsx");
